import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";

const AlertDialog = ({
  open,
  handleClose,
  action,
  title = "Delete Data",
  message = "Are you sure you want to delete this data",
  yesTitle = "Yes",
  cancelTitle = "cancel",
}) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <Typography>{title}</Typography>
      </DialogTitle>
      <DialogContent
        sx={{ minWidth: "280px", width: "70vw", maxWidth: "550px" }}
      >
        <DialogContentText id="alert-dialog-description">
          <Typography>{message}</Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="secondary" onClick={handleClose}>
          <Typography>{cancelTitle}</Typography>
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            action();
            handleClose();
          }}
          autoFocus
        >
          <Typography>{yesTitle}</Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
